import type { ReactNode } from 'react'
import { RefreshCw } from 'lucide-react'

import { Button, StatusMessage } from '@krp/ui-kit'

import './vatSettings.css'

/**
 * «Номенклатура → Настройка»: ставка НДС товаров по источникам. Каждый источник — своя карточка
 * (<code>VatSourceCard</code>), которую собирает binding; экран только раскладывает их и даёт «Обновить все».
 */
export function VatSettingsScreen({
  cards,
  onReloadAll,
  emptyText,
}: {
  cards: readonly { id: string; node: ReactNode }[]
  onReloadAll: () => void
  /** Нет ни одного источника, где человеку разрешено читать каталог. */
  emptyText: string | null
}) {
  return (
    <section aria-labelledby="platform-vat-title" className="platform-vat">
      <header className="platform-vat__toolbar">
        <div>
          <h2 id="platform-vat-title">Настройка: ставка НДС товаров</h2>
          <p className="platform-vat__lead">
            Кассовый агент берёт ставку НДС строки чека у товара. Товар без ставки продать нельзя, поэтому ставку проверяют и исправляют
            здесь, в одном месте. Ставка задаётся в учётной системе (1С).
          </p>
        </div>
        <Button
          variant="ghost"
          icon={<RefreshCw size={16} aria-hidden="true" />}
          onClick={onReloadAll}
          actionId="platform.nomenclature-settings.reload"
        >
          Обновить
        </Button>
      </header>
      {emptyText !== null && <StatusMessage kind="empty" title={emptyText} />}
      <div className="platform-vat__cards">
        {cards.map((card) => (
          <div key={card.id}>{card.node}</div>
        ))}
      </div>
    </section>
  )
}
